import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const GET_BUYING_GUIDE_REQUEST = 'GET_BUYING_GUIDE_REQUEST';
export const GET_BUYING_GUIDE_SUCCESS = 'GET_BUYING_GUIDE_SUCCESS';
export const GET_BUYING_GUIDE_ERROR = 'GET_BUYING_GUIDE_ERROR';

export function getBuyingGuideRequestAction() {
	return { type: GET_BUYING_GUIDE_REQUEST };
}

export function getBuyingGuideSuccessAction(data) {
	return { type: GET_BUYING_GUIDE_SUCCESS, data };
}

export function getBuyingGuideErrorAction(error) {
	return { type: GET_BUYING_GUIDE_ERROR, error };
}

export function fetchBuyingGuideAction(storeId) {
	return dispatch => {
		dispatch(getBuyingGuideRequestAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/buying-guide?sid=${storeId}`
			}),
			{}
		).then(
			json => dispatch(getBuyingGuideSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getBuyingGuideErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
